import {useLayoutEffect,useMemo,useRef,useSyncExternalStore} from 'react';
import {createPlacementClient,placementAccountKey,type PlacementClient} from '../client';
import {createDraft} from '../../browser-recovery/drafts';
import {emptyEarlierBindingDraft,validEarlierBindingDraft} from '../earlier-client';
import {emptyPlacementDraft,validPlacementDraft} from '../draft';
import {emptyOutcomeDraft,validOutcomeDraft} from '../outcome-draft';
import type {PlacementAccount} from '../types';
const clients=new Map<string,PlacementClient>();
if(typeof window!=='undefined'){
 window.addEventListener('storage',()=>clients.forEach(c=>c.refreshSaved()));
 window.addEventListener('beforeunload',e=>{if([...clients.values()].some(c=>c.snapshot().pending)){e.preventDefault();e.returnValue='';}});
}
export function usePlacementClient(base:string,account:PlacementAccount,begin?:()=>()=>void){
 const key=placementAccountKey(base,account),live=useRef(key);live.current=key;
 useLayoutEffect(()=>{live.current=key;return()=>{live.current='';};},[key]);
 if(!clients.has(key))clients.set(key,createPlacementClient(base,account,begin));
 const client=clients.get(key)!;client.activate(()=>live.current===key);
 const state=useSyncExternalStore(client.subscribe,client.snapshot);
 return {client,key,...state,locked:state.busy||!!state.pending||state.blocked};
}
export function usePlacementDraft(key:string){
 const store=useMemo(()=>createDraft(key,'put-away-v1',emptyPlacementDraft(),validPlacementDraft),[key]);
 const state=useSyncExternalStore(store.subscribe,store.snapshot);
 return {...store,...state,locked:state.stale||state.changedElsewhere||state.unreadable||!!state.error};
}

export function useEarlierPlacementDraft(key:string){const store=useMemo(()=>createDraft(key,'put-away-earlier-v1',emptyEarlierBindingDraft(),validEarlierBindingDraft),[key]),state=useSyncExternalStore(store.subscribe,store.snapshot);return {...store,...state,locked:state.stale||state.changedElsewhere||state.unreadable||!!state.error};}

export function useOutcomeDraft(key:string){const store=useMemo(()=>createDraft(key,'put-away-outcome-v1',emptyOutcomeDraft(),validOutcomeDraft),[key]),state=useSyncExternalStore(store.subscribe,store.snapshot);return {...store,...state,locked:state.stale||state.changedElsewhere||state.unreadable||!!state.error};}
